import { Grid2 } from '@mui/material';
import React from 'react';

import { RoleAdminControl } from '@components/Admin';

import { usePageContext } from '@contexts/page-context';

import { useAdminGetRole } from 'generated/admin.generated';

import MetadataEditor from './MetadataEditor';

interface RoleDrilldownProps {
  role_id: string;
}

const RoleDrilldown = ({
  role_id,
}: React.PropsWithChildren<RoleDrilldownProps>) => {
  const { data, loading } = useAdminGetRole({
    variables: { input: { role_id } },
  });
  const { setTitle } = usePageContext();

  const role = data?.getRole;

  React.useEffect(() => {
    if (role?.role_name) {
      setTitle(role.role_name);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [role?.role_name]);

  return (
    <Grid2 container spacing={1}>
      <Grid2 size={{ xs: 12, sm: 6 }}>
        <MetadataEditor loading={loading} role={role} />
      </Grid2>
      <Grid2 size={{ xs: 12, sm: 6 }}>
        <RoleAdminControl.PolicyEditor loading={loading} role={role} />
      </Grid2>
    </Grid2>
  );
};

export default RoleDrilldown;
